<template>
  <div class="product-heading">
    <h1 class="product-title">
      {{ product.name }}
    </h1>
    <WishlistIcon
      :is-pdp="true"
      class="product__add-to-wishlist"
      :is-in-wishlist="isInWishlist"
      @addToWishlist="$emit('addToWishlist')"
    />
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import WishlistIcon from '~/components/Products/WishlistIcon.vue';

// import {} from '@storefront-ui/vue';

export default defineComponent({
  name: 'ProductTitle',
  components: { WishlistIcon },
  props: {
    product: {
      type: Object,
      required: true,
    },
    isInWishlist: {
      type: Boolean,
      default: false,
    },
  },
  setup() {},
});
</script>

<style lang="scss" scoped>
.product-heading {
  display: flex;
}
.product-title {
  @include desktop-h6;
  width: 100%;
  color: var(--c-black);
  padding: 0 0 0.625rem 0;
  margin: 0;
}
</style>
